/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _404Inputs */



/**
* | output |
* | --- |
* | "Sorry, the page you are looking for does not exist" |
*
* @param {_404Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const _404 = /** @type {((inputs?: _404Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_404Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Sorry, the page you are looking for does not exist")
	return /** @type {LocalizedString} */ ("Désolé, la page que vous recherchez n'existe pas")
});
export { _404 as "404" }